export const API_ROUTE_RULES = "/api/v1/rules";
export const API_ROUTE_RULES_ALL = "/api/v1/rules-all";
export const API_ROUTE_CALL_CENTER = "/api/v1/rules-call-center";
export const API_ROUTE_RULES_BLLT = "/api/v1/rules-bllt";
export const API_ROUTE_RULES_LTNT = "/api/v1/rules-ltnt";
export const API_ROUTE_LEAD_NOTES = "/api/v1/lead/:id/notes";
